import React from 'react'

function Decline ({ className, fill }) {
  return (
    <svg fill={fill} className={className} width='9.257' height='9.257' viewBox='0 0 9.257 9.257'>
      <g transform='translate(-8.948 4.628) rotate(-45)'>
        <path d='M96,202.668h12v1.091H96Zm0,0' transform='translate(-92.4 -193.613)' />
        <path d='M202.668,96h1.091v12h-1.091Zm0,0' transform='translate(-193.613 -92.4)' />
      </g>
    </svg>
  )
}

Decline.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default Decline
